import { type IEntitiesStore } from 'entities/EntitiesExport'

export const logCreateReviewEvent = (entities: IEntitiesStore) => {
  entities.eventLogStore.logEvent(
    'Create Review',
    { event_id: 'create_review' },
    { groupId: entities.organizationStore.id }
  )
}

export const logDeleteReviewEvent = (entities: IEntitiesStore) => {
  entities.eventLogStore.logEvent(
    'Delete Review',
    { event_id: 'delete_review' },
    { groupId: entities.organizationStore.id }
  )
}
